import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://klhvuayqvvdmrbjoechv.supabase.co'

const supabaseKey = 'sb_publishable_xU3j0hVLTKE49awzbtsc7A_rEmtjqeD'

export const supabase = createClient(
    supabaseUrl,
    supabaseKey
)